import { PollData_Design_PollDesign_Background_Type as PollData_Design_PollDesign_Background_Type$1, PluginContainerData_Width_Type, PluginContainerData_Alignment, PollData_Poll_Settings_Permissions_ViewRole, PollData_Poll_Settings_Permissions_VoteRole, PollData_Layout_PollLayout_Type, PollData_Layout_PollLayout_Direction } from 'ricos-schema';
import { PollData_Design_PollDesign_Background_Type } from 'ricos-schema/next';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { unreachable } from 'wix-rich-content-editor-common';
import loadable from '@loadable/component';
import React, { useMemo } from 'react';
import { Node_Type } from 'ricos-types';

function getRandomValue(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}
function toBackgroundString(background, backgroundType, width, height) {
  var _a, _b;
  switch (backgroundType) {
    case PollData_Design_PollDesign_Background_Type.GRADIENT:
      try {
        var gradient = background.gradient;
        return "linear-gradient(" + gradient.angle + "deg, " + gradient.startColor + ", " + gradient.lastColor + ")";
      } catch (error) {
        console.error(error);
        return null;
      }
    case PollData_Design_PollDesign_Background_Type.IMAGE:
      if (!width || !height) {
        return null;
      }
      var URL = (_b = (_a = background.image) == null ? void 0 : _a.src) == null ? void 0 : _b.url;
      var imageSrc = getScaleImageSrc(URL, width, height);
      return "url('" + imageSrc + "') center / cover";
    case PollData_Design_PollDesign_Background_Type.COLOR:
      return background.color;
    default:
      unreachable(backgroundType);
      return background.color;
  }
}

var _BACKGROUND_PRESETS;
var BACKGROUND_PRESETS = (_BACKGROUND_PRESETS = {}, _BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type$1.COLOR] = ["#EF4538", "#F96132", "#FAAD4D", "#31B778", "#488FFE", "#11428D", "#6C49EF", "#8C0F7A"], _BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type$1.IMAGE] = ["https://static.wixstatic.com/media/2dfdd3_03c2331b19bb41108b34938edf8951dd~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_df028f9258cf4fe0a1b7f75a3916def1~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_1977932e94064f168abaaa2c04b678a5~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_17b428ae1fb14736a2ab30994620ee62~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_934a080451cd4b3eb6e7c9485a07972c~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_0b440a1138ba4c99bc954eb4d06ec0ad~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_395a5522e3474b3ca34194633e90ea81~mv2.jpg"], _BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type$1.GRADIENT] = [{
  angle: 45,
  startColor: "#EF4538",
  lastColor: "#488FFE"
}, {
  angle: 45,
  startColor: "#F96132",
  lastColor: "#FAAD4D"
}, {
  angle: 45,
  startColor: "#31B778",
  lastColor: "#FAAD4D"
}, {
  angle: 45,
  startColor: "#0D6546",
  lastColor: "#31B778"
}, {
  angle: 45,
  startColor: "#488FFE",
  lastColor: "#8C0F7A"
}, {
  angle: 45,
  startColor: "#11428D",
  lastColor: "#488FFE"
}, {
  angle: 45,
  startColor: "#6C49EF",
  lastColor: "#31B778"
}, {
  angle: 45,
  startColor: "#8C0F7A",
  lastColor: "#FAAD4D"
}].map(function (value) {
  return JSON.stringify(value);
}), _BACKGROUND_PRESETS);
var OPTION_IMAGES_POOL = ["https://static.wixstatic.com/media/fb62d9f8e7824b2e90b13b971e700b92.jpg", "https://static.wixstatic.com/media/3a27828e768344158489df4f2c03cfb2.jpg"];
var POLL_IMAGES_POOL = ["https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg"];
var DEFAULT_RICOS_COMPONENT_DATA = {
  containerData: {
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  },
  poll: {
    title: "",
    settings: {
      permissions: {
        view: PollData_Poll_Settings_Permissions_ViewRole.VOTERS,
        vote: PollData_Poll_Settings_Permissions_VoteRole.ALL,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    },
    options: []
  },
  layout: {
    poll: {
      type: PollData_Layout_PollLayout_Type.LIST,
      direction: PollData_Layout_PollLayout_Direction.LTR,
      enableImage: true
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: PollData_Design_PollDesign_Background_Type$1.IMAGE,
        image: {
          src: {
            url: getRandomValue(BACKGROUND_PRESETS[PollData_Design_PollDesign_Background_Type$1.IMAGE])
          }
        }
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};

var POLL_TYPE = "wix-draft-plugin-poll";

var _nodeViewRenderers;
function _createForOfIteratorHelperLoose$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var PollRenderer = function PollRenderer(_a) {
  var _b = _a,
    node = _b.node,
    nodeIndex = _b.nodeIndex,
    NodeViewContainer = _b.NodeViewContainer,
    props = __objRest(_b, ["node", "nodeIndex", "NodeViewContainer"]);
  var Poll = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_poll";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_poll" */'./poll.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./poll");
        }
        return eval('require.resolve')("./poll");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(Poll, __spreadValues$1({
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var PollLoadable = function PollLoadable(_c) {
  var _d = _c,
    node = _d.node,
    nodeIndex = _d.nodeIndex,
    NodeViewContainer = _d.NodeViewContainer,
    props = __objRest(_d, ["node", "nodeIndex", "NodeViewContainer"]);
  return /* @__PURE__ */React.createElement(PollRenderer, __spreadValues$1({
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.POLL] = PollLoadable, _nodeViewRenderers);

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginPoll = function pluginPoll(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_RICOS_COMPONENT_DATA.containerData), config),
    type: POLL_TYPE,
    nodeViewRenderers: nodeViewRenderers
  };
};

export { OPTION_IMAGES_POOL as O, POLL_IMAGES_POOL as P, POLL_TYPE as a, getRandomValue as g, pluginPoll as p, toBackgroundString as t };
